export const SDK_SETUP_HEADING = 'Connect your app to LaunchDarkly';
export const SDK_SETUP_DESCRIPTION =
  'Install an SDK of your choice in your application to start controlling features in real time. Once connected, you can create flags, target users, and ship changes safely from your own codebase.';
